import { FC } from 'react';
import {ICustomer} from "../../../model";
import {NexParkLocationsGrid} from "../../../pages/locations/nexParkInstance/NexParkLocationsGrid";
import {BillingMode} from "../../../model/api/customers/billing-mode";
import styles from './LocationsSection.module.scss';

interface INexParkLocationsSectionProps {
  customer: ICustomer;
  billingMode: BillingMode;
}

export const NexParkLocationsSection: FC<INexParkLocationsSectionProps> = ({ customer, billingMode }) => {
  return (
    <div className={styles.tableResponsiveWrapper}>
      <NexParkLocationsGrid customerName={customer.name} customerId={customer.id} billingMode={billingMode} regionId={customer.nexResponseRegionId || 0} />
    </div>
  );
};
